import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`notifications/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getUsersNotifications(UserId, NotificationId, keyword, pageNumber, pageSize, order) {
        return Api().get(`notifications/users/adm?UserId=${UserId}&NotificationId=${NotificationId}&keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getTotaisUsersNotifications(NotificacaoId) {
        return Api().get(`notifications/users/totais/${NotificacaoId}`);
    },
    getJob(jobId) {
        return Api().get(`notifications/jobs/${jobId}`);
    },
    getOne(id) {
        return Api().get(`notifications/adm/${id}`);
    },
    create(data){
        const formData = new FormData();
        
        const jsonFields = ['buttons', 'variaveis', 'canais', 'Users', 'applicationData'];
        const skipFields = ['whatsappData', 'emailData', 'mediaUrl'];
        
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value === null || value === undefined) return;
            if (skipFields.includes(key)) return;
            
            if (jsonFields.includes(key)) {
                const payloadValue = key === 'Users' && Array.isArray(value)
                    ? value.map(user => user?.id || user).filter(Boolean)
                    : value;
                formData.append(key, JSON.stringify(payloadValue));
            } else if (value instanceof File) {
                formData.append(key, value);
            } else if (typeof value === 'object') {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        });
        
        const mediaFile = data.whatsappData?.mediaUrl;

        if (mediaFile) {
            if (mediaFile instanceof File || mediaFile instanceof Blob) {
                formData.append('mediaUrl', mediaFile);
            } else if (mediaFile.name && mediaFile.size && mediaFile.type) {
                formData.append('mediaUrl', mediaFile);
            } else if (typeof mediaFile === 'string' && mediaFile) {
                // Notificação duplicada: reaproveita a URL de imagem já existente.
                formData.append('mediaUrl', mediaFile);
            }
        }
        
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        return Api().post(`notifications`, formData, config);
    },
    update(data) {
        return Api().put(`notifications/${data.id}`, data);
    },
    remove(id) {
        return Api().delete(`notifications/${id}`);
    },
    test(data) {
        const formData = new FormData();

        const jsonFields = ['buttons', 'variaveis', 'admIds', 'phones'];

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value === null || value === undefined) return;
            if (key === 'mediaUrl' || key === 'mediaFile') return;

            if (jsonFields.includes(key)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof File) {
                formData.append(key, value);
            } else if (typeof value === 'object') {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        });

        // Mídia: arquivo recém-selecionado (File/Blob) ou URL já existente.
        const mediaFile = data.mediaFile;
        if (mediaFile instanceof File || mediaFile instanceof Blob) {
            formData.append('mediaUrl', mediaFile);
        } else if (typeof data.mediaUrl === 'string' && data.mediaUrl) {
            formData.append('mediaUrl', data.mediaUrl);
        }

        return Api().post('notifications/test', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    resend_NotificationUserChannel(data) {
        return Api().post('notifications/resend_NotificationUserChannel', data);
    }
}